import { render, staticRenderFns } from "./FirmaConfig.vue?vue&type=template&id=93ad9918&scoped=true"
import script from "./FirmaConfig.vue?vue&type=script&lang=js"
export * from "./FirmaConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ad9918",
  null
  
)

export default component.exports